import { AlgoliaSearchParams } from "../../../../api/postCall/algoliaSearch";

export const generatePayloadForInitialDataFetch = (
  payload: AlgoliaSearchParams,
  batchNumber: number,
  searchTerm: string,
) => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...payload,
    page: index,
    query: searchTerm,
  }));
};
